// --- React & Redux
import React from "react";
import { useSelector } from "react-redux";
// --- External UI Libraries
import { Drawer } from "antd";
// --- Hooks & Actions
import { useOffersActions } from "tap/store/offers/useOffers.js";
import Button from "@dtci/spellbook/Button";
import { OffersUploadTasksForm } from "./tasks-form";

export const OffersUploadTasksDrawer = ({ onOpenUploadDialog }) => {
  const { isOffersUploadTasksDrawerOpen, selectedJob } = useSelector(
    (state) => state.offers,
  );
  const isTprJob = !!selectedJob?.isTpr;
  const { updateOffers } = useOffersActions();

  const handleClose = () => {
    updateOffers({
      isOffersUploadTasksDrawerOpen: false,
      offersUploadJobTasks: [],
    });
  };

  return (
    <Drawer
      className="create-drawer"
      title="Upload Tasks"
      width={750}
      placement="right"
      open={isOffersUploadTasksDrawerOpen}
      onClose={handleClose}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div
          className="button-row"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            iconType="fa-solid fa-xmark"
            labelText="close"
            styleType="link"
            onClick={handleClose}
          >
            Cancel
          </Button>
          {!isTprJob && (
            <Button
              iconType="fa-solid fa-upload"
              labelText="Upload"
              styleType="link"
              onClick={() => {
                onOpenUploadDialog();
                handleClose();
              }}
            >
              Upload
            </Button>
          )}
        </div>
      }
    >
      <OffersUploadTasksForm />
    </Drawer>
  );
};
